import { Volume2, VolumeX } from 'lucide-react';

import { Button } from '@/components/Button/Button';
import { Tooltip } from '@/components/Tooltip/Tooltip';

import controlBarStyles from './ControlBar.module.css';
import styles from './VolumeControl.module.css';

interface VolumeControlProps {
  isMuted: boolean;
  onToggleMute: () => void;
  onVolumeChange: (volume: number) => void;
  /** Why neither Mute nor the slider can be used yet, while the player loads. */
  unavailableReason?: string;
  volume: number;
}

export function VolumeControl({
  isMuted,
  onToggleMute,
  onVolumeChange,
  unavailableReason,
  volume,
}: VolumeControlProps) {
  const label = isMuted ? 'Unmute' : 'Mute';
  const Icon = isMuted ? VolumeX : Volume2;

  return (
    <div className={styles.wrapper}>
      <Tooltip content={unavailableReason ?? label}>
        <Button
          aria-disabled={unavailableReason ? 'true' : undefined}
          aria-label={label}
          className={controlBarStyles.iconButton}
          iconOnly
          onClick={unavailableReason ? undefined : onToggleMute}
          size="small"
          title={unavailableReason}
          variant="ghost"
        >
          <Icon
            aria-hidden="true"
            className={controlBarStyles.controlIcon}
            size={20}
          />
        </Button>
      </Tooltip>
      <label className={styles.sliderLabel}>
        <input
          aria-disabled={unavailableReason ? 'true' : undefined}
          aria-label="Volume"
          className={styles.slider}
          max={100}
          min={0}
          onChange={(event) => {
            // The slider stays where it was: the value is the player's.
            if (!unavailableReason) {
              onVolumeChange(Number(event.currentTarget.value));
            }
          }}
          step={1}
          title={unavailableReason}
          type="range"
          value={volume}
        />
      </label>
    </div>
  );
}
